const TOP_OFFSET = 100;
/**
 * @internal Not for public usage
 */
const useSize = (props) => {
    if (props.width)
        return props.width;
    return {
        large: 960,
        medium: 720,
        small: 460,
    }[props.size];
};
/**
 * @internal Not for public usage
 */
const useStyles = (props) => {
    var _a;
    if (props.centered) {
        return [props.style, props.bodyStyle];
    }
    if (props.scroll === 'body') {
        const topValue = ((_a = props === null || props === void 0 ? void 0 : props.style) === null || _a === void 0 ? void 0 : _a.top) || TOP_OFFSET;
        const top = typeof topValue === 'string' ? topValue : `${topValue}px`;
        return [
            Object.assign(Object.assign({}, props.style), { top, height: `calc(100vh - ${top})` }),
            Object.assign(Object.assign({}, props.bodyStyle), { overflowY: 'auto' }),
        ];
    }
    return [Object.assign({ top: TOP_OFFSET }, props.style), props.bodyStyle];
};

export { useSize, useStyles };
//# sourceMappingURL=hooks.js.map
